// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tu88","col":"styles_col__16wsW"};